export const pages = {
	'boltWatchMore': { id: 'boltWatchMore', page: 'home', getter: () => import(/* webpackChunkName: 'home' */ 'components/bolt/home/home') }
};
export const sections = [
	{ id: 'boltWatchMore', getter: () => import(/* webpackChunkName: "watchMore" */ 'components/bolt/watchMore/watchMore'), component: 'watchMore', parent: 'boltWatchMore' }
];
import SidePanelLoader from 'components/bolt/sidePanelLoader/sidePanelLoader';
export { SidePanelLoader };
